import { all, call, put, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import { NAVIGATION_BLOCKS } from '../../../../Data/Constants';
import { getAppointments } from './getAppointmentsQuery';

/**
 * setNavigationBlocks
 * For all the pages in the array, set the navigation block to prevent navigation.
 */
function* setNavigationBlocks({ isPreventingNavigation, blockName, pages }) {
  yield all(
    pages.map((pageNumber) =>
      put({
        type: 'NAVIGATION_CONTROLS/setNavigationBlockOnPage',
        payload: {
          pageNumber,
          blockName,
          isPreventingNavigation,
        },
      })
    )
  );
}

function* worker(action) {
  const { payload } = action;
  const { postcode, country, provider, locale, appointmentBookingPage } =
    payload;

  try {
    // Prevent navigation until the appointments have been retrieved
    yield put({ type: 'GET_APPOINTMENTS_STARTED' });

    yield setNavigationBlocks({
      isPreventingNavigation: true,
      blockName: NAVIGATION_BLOCKS.APPOINTMENT_BOOKING,
      pages: [appointmentBookingPage],
    });

    const appointments = yield call(getAppointments, {
      postcode,
      country: country.toUpperCase(),
      provider,
      locale,
    });

    if (appointments && appointments?.length > 0) {
      // successful fetch appointments!
      yield put({
        type: 'APPOINTMENT_BOOKING/setAppointments',
        payload: { appointments },
      });
      yield setNavigationBlocks({
        isPreventingNavigation: false,
        blockName: NAVIGATION_BLOCKS.APPOINTMENT_BOOKING,
        pages: [appointmentBookingPage],
      });
    } else {
      // no appointments found
      yield put({
        type: 'APPOINTMENT_BOOKING/setAppointments',
        payload: { appointments: [] },
      });
      yield setNavigationBlocks({
        isPreventingNavigation: false,
        blockName: NAVIGATION_BLOCKS.APPOINTMENT_BOOKING,
        pages: [appointmentBookingPage],
      });
    }
  } catch (error) {
    // catch errors and continue to navigate
    yield put({ type: 'GET_APPOINTMENTS_FAILED', payload: { error } });

    yield setNavigationBlocks({
      isPreventingNavigation: false,
      blockName: NAVIGATION_BLOCKS.APPOINTMENT_BOOKING,
      pages: [appointmentBookingPage],
    });
  }
  yield put({ type: 'GET_APPOINTMENTS_COMPLETE' });
}

export default function* getAppointmentsSaga() {
  yield takeEvery(ActionTypes.GET_APPOINTMENTS, worker);
}
